import { batch } from "react-redux";
import { REQUEST_TYPES_ID } from "../../../utils/constant.utils";
import { actions } from 'react-redux-form';
import {
    circuitOrderFormModel,
    locationModel,
    getCircuitOrder,
    getCircuitOrderAllCircuitStatusesDropdown,
    getCircuitOrderCircuitTypesByCategoryDropdown,
    getCircuitOrderSubCircuitTypesDropdown,
    getCircuitOrderAllCircuitRankingsDropdown,
    getCircuitOrderAllAccountDetailsDropdown,
    getlinkCircuitsByVendorIdAndCircuitTypeId,
    getCircuitOrderAllEmployeesDropdown,
    getCircuitOrderAllLocations,
    setCircuitOrderFormSubmitted,
    getOrderCircuitCostCenterList,
    getOrderCircuitGlCodeList,
    setLocationLoading,
    setEmployeeLoading,
    setSubCircuitTypeLoading,
    setLinkedCircuitsLoading,
    setBillingAccountLoading,
    setCostCodeLoading,
    setGlCodeLoading,
    getCircuitOrderAllLocations1,
    getCircuitOrderAllLocations2,
    setLocation1Loading,
    setLocation2Loading,
} from "../../../constants/model-reducers/external/order/order-circuit.settings";
import { httpPost, httpGet } from "../../../utils/api.utils";
import { convertDateStringToDateFormat } from "../../../utils/helpers.utils";
import { CIRCUIT_CATEGORIES } from "../../../constants/external-constants";
import Moment from 'moment';

export const circuitOrderInitialFormState = circuitOrderFormModel;
export const location1FormInitialState = locationModel;
export const location2FormInitialState = locationModel;

const defaultState = () => ({
    fetchingCircuitOrder: true,
    locationPage: 1,
    isLocationLoading: false,
    hasMoreLocation: true,
    employeePage: 1,
    hasMoreEmployees: true,
    isEmployeeLoading: false,
    subCircuitTypePage: 1,
    hasMoreSubCircuitType: true,
    isSubCircuitTypeLoading: false,
    linkedCircuitsPage: 1,
    hasMoreLinkedCircuits: true,
    isLinkedCircuitsLoading: false,
    billingAccountPage: 1,
    hasMoreBillingAccount: true,
    isBillingAccountLoading: false,
    costCodePage: 1,
    isCostCodeLoading: false,
    hasMoreCostCode: true,
    glCodePage: 1,
    isGLCodeLoading: false,
    hasMoreGLCode: true,
    location1Page: 1,
    hasMoreLocation1: true,
    isLocation1Loading: false,
    location2Page: 1,
    hasMoreLocation2: true,
    isLocation2Loading: false,
    inventoryAllLocations1: [],
    inventoryAllLocations2: []
});

const initialState = defaultState();

export const circuitOrderActions = {

    saveCircuitOrderDetails: (requestTypeId, orderDetailsId, circuitID, confirmSavePropName, validate, orderCircuitDetailId = 0) => async (dispatch, state) => {
        const { circuitOrderDetails, circuitOrderLocation1, circuitOrderLocation2 } = state().form.circuitOrderForm;
        const { circuitOrderAccessForm, circuitOrderPipForm } = state().form
        const { planDetails } = state().circuitOrderInventoryCircuitPlanDetails;
        const { circuitSimList } = state().circuitOrderInventoryCircuitSIM;
        const { circuitEquipList } = state().circuitOrderInventoryCircuitEquip;
        const { circuitCostAllocation } = state().circuitOrderInventoryCostAllocation;

        var circuitCodeConfirmation = circuitOrderDetails.circuitCodeConfirmation;
        var primarySecondaryConfirmation = circuitOrderDetails.primarySecondaryConfirmation;

        if (confirmSavePropName == "circuitCode") {
            circuitCodeConfirmation = true;
            dispatch(actions.change("circuitOrderForm.circuitOrderDetails.circuitCodeConfirmation", circuitCodeConfirmation));
        }
        else if (confirmSavePropName == "primarySecondary") {
            primarySecondaryConfirmation = true;
            dispatch(actions.change("circuitOrderForm.circuitOrderDetails.primarySecondaryConfirmation", primarySecondaryConfirmation));
        }


        const detailsForm = {
            ...circuitOrderDetails,
            circuitCodeConfirmation: circuitCodeConfirmation,
            primarySecondaryConfirmation: primarySecondaryConfirmation,
            circuitTypeID: parseInt(circuitOrderDetails.circuitTypeID),
            subCircuitTypeID: circuitOrderDetails.subCircuitTypeID ? parseInt(circuitOrderDetails.subCircuitTypeID) : null,
            monthlyRateCharge: circuitOrderDetails.monthlyRateCharge ? parseFloat(circuitOrderDetails.monthlyRateCharge) : 0.00,
            linkedCircuitID: circuitOrderDetails.linkedCircuitID ? parseInt(circuitOrderDetails.linkedCircuitID) : null,
            billingAccountID: parseInt(circuitOrderDetails.billingAccountID),
            endUserID: circuitOrderDetails.endUserID ? parseInt(circuitOrderDetails.endUserID) : null,
            location1ID: circuitOrderLocation1.locationID ? parseInt(circuitOrderLocation1.locationID) : null,
            demarc1Location: circuitOrderLocation1.demarcLocation ? circuitOrderLocation1.demarcLocation : null,
            location2ID: circuitOrderLocation2.locationID ? parseInt(circuitOrderLocation2.locationID) : null,
            demarc2Location: circuitOrderLocation2.demarcLocation ? circuitOrderLocation2.demarcLocation : null,
            installDate: circuitOrderDetails.installDate ? Moment(circuitOrderDetails.installDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') : null,
            disconnectDate: circuitOrderDetails.disconnectDate ? Moment(circuitOrderDetails.disconnectDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') : null,
            suspensionFromDate: circuitOrderDetails.suspensionFromDate ? Moment(circuitOrderDetails.suspensionFromDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') : null,
            suspensionToDate: circuitOrderDetails.suspensionToDate ? Moment(circuitOrderDetails.suspensionToDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') : null
        };

        const accessInformationForm = {
            ...circuitOrderAccessForm,
            siteSurveyRequested: circuitOrderAccessForm.siteSurveyRequested ? parseInt(circuitOrderAccessForm.siteSurveyRequested) : null,
            accessBandwidth: circuitOrderAccessForm.accessBandwidth ? parseInt(circuitOrderAccessForm.accessBandwidth) : null,
            access: circuitOrderAccessForm.access ? parseInt(circuitOrderAccessForm.access) : null,
            isThisCoordinatedService: circuitOrderAccessForm.isCoordinatedService ? parseInt(circuitOrderAccessForm.isCoordinatedService) : null,
            electricalOpticalInterface: circuitOrderAccessForm.electricalOpticalInterface ? parseInt(circuitOrderAccessForm.electricalOpticalInterface) : null,
            requiredLOACFA: circuitOrderAccessForm.requiredLOACFA ? parseInt(circuitOrderAccessForm.requiredLOACFA) : null,
            serviceClass: circuitOrderAccessForm.serviceClass ? parseInt(circuitOrderAccessForm.serviceClass) : null,
        };

        const pipInformationForm = {
            ...circuitOrderPipForm,
            portSpeed: circuitOrderPipForm.portSpeed ? parseInt(circuitOrderPipForm.portSpeed) : null,
            carrierQOSProfile: circuitOrderPipForm.carrierQOSProfile ? parseInt(circuitOrderPipForm.carrierQOSProfile) : null,
            voiceCAR: circuitOrderPipForm.voiceCAR ? parseInt(circuitOrderPipForm.voiceCAR) : null,
            vpnName: circuitOrderPipForm.vpnName ? parseInt(circuitOrderPipForm.vpnName) : null,
            voiceCARSpeed: circuitOrderPipForm.voiceCARSpeed ? parseInt(circuitOrderPipForm.voiceCARSpeed) : null,
            asnNewOrExisting: circuitOrderPipForm.asnNewOrExisting ? parseInt(circuitOrderPipForm.asnNewOrExisting) : null,
            siteOfOrigin: circuitOrderPipForm.siteOfOrigin ? parseInt(circuitOrderPipForm.siteOfOrigin) : null
        };

        var planDetailsData = planDetails.datatable;
        var planId = planDetailsData.length > 0 ? (planDetailsData[0].dataItem.length > 0 ? planDetailsData[0].dataItem[0].PlanId : null) : null;
        var simData = circuitSimList.datatable.length > 0 ? circuitSimList.datatable[0].dataItem : [];
        var equipmentData = circuitEquipList.datatable.length > 0 ? circuitEquipList.datatable[0].dataItem : [];
        var circuitCostAllocations = circuitCostAllocation.datatable.length > 0 ? circuitCostAllocation.datatable[0].dataItem : [];

 
        var formData = {
            ...detailsForm,
            accessInformation: {
                ...accessInformationForm
            },
            pipInformation: {
                ...pipInformationForm
            },
            planID: planId ? parseInt(planId) : null,
            circuitSIMs: simData,
            circuitEquipments: equipmentData,
            circuitCostAllocations: circuitCostAllocations
        };

        circuitID = (
            requestTypeId == REQUEST_TYPES_ID.newMobile
            || requestTypeId == REQUEST_TYPES_ID.simAndDevice
            || requestTypeId == REQUEST_TYPES_ID.newMobileDevice
            || requestTypeId == REQUEST_TYPES_ID.wifiDongleAndDataCard
            || requestTypeId == REQUEST_TYPES_ID.simAndDeviceBSA
            || requestTypeId == REQUEST_TYPES_ID.simOnlyBSA
            || requestTypeId == REQUEST_TYPES_ID.multiSIMBSA
            || requestTypeId == REQUEST_TYPES_ID.wifiDongleAndDataCardBIN
            || requestTypeId == REQUEST_TYPES_ID.voiceSIMBIN
            || requestTypeId == REQUEST_TYPES_ID.wifiDongleDataCardAndVoiceSIMBIN
            || requestTypeId == REQUEST_TYPES_ID.portIn
        ) ? 0 : circuitID;

        var result = await httpPost(`external/order/saveCircuitOrder/${requestTypeId}/${orderDetailsId}/${circuitID}/${validate}/${orderCircuitDetailId}`, formData);

        dispatch(actions.resetErrors('circuitOrderForm'));

        if (result.success == false) {
            if (result.propertyName == "circuitCode") {
                dispatch(actions.setErrors("circuitOrderForm.circuitOrderDetails.circuitCode", true));
            }
            else if (result.propertyName == "primarySecondary") {
                dispatch(actions.setErrors("circuitOrderForm.circuitOrderDetails.primarySecondary", true));
            }
            else if (result.propertyName == "circuitSIMs") {
                dispatch(actions.setErrors("circuitOrderForm.circuitSIMs", true));
            }
            else if (result.propertyName == "circuitCostAllocations") {
                dispatch(actions.setErrors("circuitOrderForm.circuitCostAllocations", true));
            }
        }

        return result;
    },
    getOrderLocation: (pageIndex=1, searchString='')=> async (dispatch, state)=>{
         var circuitAllLocations = await getCircuitOrderAllLocationsDropdown(pageIndex, searchString, dispatch);
         dispatch({
            type: getCircuitOrderAllLocations,
            payload: {
                data: circuitAllLocations,
                locationPage: pageIndex
            }
        });
    },
    getCircuitOrder: (orderId, requestTypeId, isOrderDetailsTab = false, isCirDetailsDidMount = false, ranking) => async (dispatch,state) => {
        dispatch({
            type: getCircuitOrder,
            data: {
                fetching: true
            }
        });

        var result = await httpGet(`external/order/getCircuitOrder/${orderId}/${requestTypeId}/${isOrderDetailsTab}/${ranking}`);
        var data = result.data;
        if (data == null)
        {
            return data;
        }
        var vendorId = result.data.VendorID;

        if (!isCirDetailsDidMount)
        {
            await dispatch(circuitOrderActions.getCircuitOrderAllEmployees(1, data?.EndUserHRID));
        }

        if (!isOrderDetailsTab && !isCirDetailsDidMount)
        {  
            var isFixedOrMobile = (requestTypeId === REQUEST_TYPES_ID.terminateSubscriptionWireline 
                || requestTypeId === REQUEST_TYPES_ID.wirelineChangeVendor 
                || requestTypeId === REQUEST_TYPES_ID.newSubscriptionWireline
                || requestTypeId === REQUEST_TYPES_ID.wirelineChangeLocationAddress
                || requestTypeId === REQUEST_TYPES_ID.wirelineOtherOther
                || requestTypeId === REQUEST_TYPES_ID.wirelineUpgradeCircuit
                || requestTypeId === REQUEST_TYPES_ID.updatePlanWireline)
                   ? CIRCUIT_CATEGORIES.fixed : CIRCUIT_CATEGORIES.mobile
            var circuitStatuses = await getCircuitOrderAllCircuitStatuses();
            var circuitCircuitTypeByCategory = await getCircuitOrderCircuitTypesByCategory(isFixedOrMobile);
            await dispatch(circuitOrderActions.getCircuitOrderSubCircuitTypes(data.CircuitTypeId, 1, data?.SubCircuitTypeName));
            var circuitRankings = await getCircuitOrderAllCircuitRankings();
            await dispatch(circuitOrderActions.getCircuitOrderAllLocations1(1, data.LocationAddress?.LocationSite));
            await dispatch(circuitOrderActions.getCircuitOrderAllLocations2(1, data.LocationP2P?.LocationSite));
            await dispatch(circuitOrderActions.getCircuitOrderAllAccountDetails(vendorId, 1, data?.BillingAccount));
            await dispatch(circuitOrderActions.GetlinkCircuitsByVendorIdAndCircuitTypeId(data.CircuitId ? data.CircuitId : 0, data.CircuitTypeId ? data.CircuitTypeId : 0, vendorId ? vendorId : 0, 1, ''));        
            await dispatch(circuitOrderActions.getOrderCircuitCostCenterListDropdown(1, ''));
            await dispatch(circuitOrderActions.getOrderCircuitGlCodeListDropdown(1, ''));
           
        }
        if (data) {
            batch(() => {

                dispatch({
                    type: getCircuitOrderAllCircuitStatusesDropdown,
                    data: circuitStatuses
                });
                dispatch({
                    type: getCircuitOrderCircuitTypesByCategoryDropdown,
                    data: circuitCircuitTypeByCategory
                });
                dispatch({
                    type: getCircuitOrderAllCircuitRankingsDropdown,
                    data: circuitRankings
                });

                dispatch(actions.load('circuitOrderForm.circuitOrderDetails.circuitID', data.CircuitId));
                dispatch(actions.load('circuitOrderForm.circuitOrderDetails.circuitCode', data.CircuitCode));
                dispatch(actions.load('circuitOrderForm.circuitOrderDetails.statusID', data.CircuitStatusID));
                dispatch(actions.load('circuitOrderForm.circuitOrderDetails.circuitTypeID', data.CircuitTypeId));
                dispatch(actions.load('circuitOrderForm.circuitOrderDetails.subCircuitTypeID', data.SubCircuitTypeId));
                dispatch(actions.load('circuitOrderForm.circuitOrderDetails.monthlyRateCharge', data.MRC == 0 ? "0.00" : data.MRC));
                dispatch(actions.load('circuitOrderForm.circuitOrderDetails.primarySecondary', data.PrimarySecondary));
                dispatch(actions.load('circuitOrderForm.circuitOrderDetails.linkedCircuitID', data.LinkedCircuitID));
                dispatch(actions.load('circuitOrderForm.circuitOrderDetails.billingAccountID', data.FinanceAccountID));
                dispatch(actions.load('circuitOrderForm.circuitOrderDetails.endUserID', data.EndUserID));
                dispatch(actions.load('circuitOrderForm.circuitOrderDetails.installDate', data.InstallDate != null ? convertDateStringToDateFormat(data.InstallDate, false) : ''));
                dispatch(actions.load('circuitOrderForm.circuitOrderDetails.disconnectDate', data.DisconDate != null ? convertDateStringToDateFormat(data.DisconDate, false) : ''));
                dispatch(actions.load('circuitOrderForm.circuitOrderDetails.suspensionFromDate', data.SuspensionFromDate != null ? convertDateStringToDateFormat(data.SuspensionFromDate, false) : ''));
                dispatch(actions.load('circuitOrderForm.circuitOrderDetails.suspensionToDate', data.SuspensionToDate != null ? convertDateStringToDateFormat(data.SuspensionToDate, false) : ''));
                dispatch(actions.load('circuitOrderForm.circuitOrderDetails.financeAccountTypeName', data.FinanceAccountTypeName));
                dispatch(actions.load('circuitOrderForm.circuitOrderDetails.currency', data.CurrencyName));
                dispatch(actions.load('circuitOrderForm.circuitOrderDetails.clientName', data.ClientName));
                dispatch(actions.load('circuitOrderForm.circuitOrderDetails.vendor', data.Vendor));
                dispatch(actions.load('circuitOrderForm.circuitOrderDetails.userName', data.LastnameFirstname));
                dispatch(actions.load('circuitOrderForm.circuitOrderDetails.emailAddress', data.EmailAdd));
                dispatch(actions.load('circuitOrderForm.circuitOrderDetails.lineManager', data.LineManager));
                dispatch(actions.load('circuitOrderForm.circuitOrderDetails.vendorID', data.VendorID));

                dispatch(actions.load('circuitOrderForm.circuitOrderLocation1.locationID', data.Location1ID));
                dispatch(actions.load('circuitOrderForm.circuitOrderLocation2.locationID', data.Location2ID));

   
                dispatch(actions.load('circuitOrderForm.circuitOrderLocation1.locationID', data.LocationAddress?.LocationId));
                dispatch(actions.load('circuitOrderForm.circuitOrderLocation1.locationSite', data.LocationAddress?.LocationSite));
                dispatch(actions.load('circuitOrderForm.circuitOrderLocation1.address1', data.LocationAddress?.LocationAddress1));
                dispatch(actions.load('circuitOrderForm.circuitOrderLocation1.address2', data.LocationAddress?.LocationAddress2));
                dispatch(actions.load('circuitOrderForm.circuitOrderLocation1.locationType', data.LocationAddress?.LocationType));
                dispatch(actions.load('circuitOrderForm.circuitOrderLocation1.locationCity', data.LocationAddress?.LocationCity));
                dispatch(actions.load('circuitOrderForm.circuitOrderLocation1.locationState', data.LocationAddress?.LocationState));
                dispatch(actions.load('circuitOrderForm.circuitOrderLocation1.locationCountry', data.LocationAddress?.CountryName));
                dispatch(actions.load('circuitOrderForm.circuitOrderLocation1.locationZip', data.LocationAddress?.LocationZip));

                dispatch(actions.load('circuitOrderForm.circuitOrderLocation1.demarcLocation', data.DemarcLocation ?? ''));

                
                dispatch(actions.load('circuitOrderForm.circuitOrderLocation2.locationID', data.LocationP2P?.LocationId));
                dispatch(actions.load('circuitOrderForm.circuitOrderLocation2.locationSite', data.LocationP2P?.LocationSite));
                dispatch(actions.load('circuitOrderForm.circuitOrderLocation2.address1', data.LocationP2P?.LocationAddress1));
                dispatch(actions.load('circuitOrderForm.circuitOrderLocation2.address2', data.LocationP2P?.LocationAddress2));
                dispatch(actions.load('circuitOrderForm.circuitOrderLocation2.locationType', data.LocationP2P?.LocationType));
                dispatch(actions.load('circuitOrderForm.circuitOrderLocation2.locationCity', data.LocationP2P?.LocationCity));
                dispatch(actions.load('circuitOrderForm.circuitOrderLocation2.locationState', data.LocationP2P?.LocationState));
                dispatch(actions.load('circuitOrderForm.circuitOrderLocation2.locationCountry', data.LocationP2P?.CountryName));
                dispatch(actions.load('circuitOrderForm.circuitOrderLocation2.locationZip', data.LocationP2P?.LocationZip));

                dispatch(actions.load('circuitOrderForm.circuitOrderLocation2.demarcLocation', data.DemarcLocationPTP ?? ''));
                dispatch(actions.load('circuitOrderForm.circuitOrderDetails.orderStatusID', data.OrderStatusId));

                dispatch({
                    type: getCircuitOrder,
                    data: {
                        fetching: false, 
                        CircuitOrderId: data.CircuitOrderId,
                        CircuitId: data.CircuitId,
                        OrderId: data.OrderId,
                        OrderCircuitDetailId: data.OrderCircuitDetailId
                    }
                });
            });

            return data;
        }
    },
    updateCircuitMRC: (mrc) => (dispatch, state) => {
        dispatch(actions.change('circuitOrderForm.circuitOrderDetails.monthlyRateCharge', mrc));
    },
    selectUserHRID: (value, endUserID) => (dispatch, state) => {
        const { CircuitOrderAllEmployeesDropdown } = state().circuitOrder;

        var res = CircuitOrderAllEmployeesDropdown.find(r => r.EmployeeID == value);

        dispatch(actions.change(endUserID.model, value));
        dispatch(actions.change('circuitOrderForm.circuitOrderDetails.userName', ""+ res.LastnameFirstname));
        dispatch(actions.change('circuitOrderForm.circuitOrderDetails.emailAddress', ""+ res.Email));
        dispatch(actions.change('circuitOrderForm.circuitOrderDetails.lineManager', res.FirstLineManagerEmail != null ? "" + res.FirstLineManagerEmail : ""));

    },
    selectLocation: (model, locationID) => (dispatch, state) => {
        const { inventoryAllLocations1, inventoryAllLocations2 } = state().circuitOrder;

        let newCircuitLocation = null;
        if (model.includes("circuitOrderLocation1")) {
            newCircuitLocation = Array.isArray(inventoryAllLocations1)
                ? inventoryAllLocations1.find(r => parseInt(r.LocationId) === parseInt(locationID))
                : null;
        }
        else if (model.includes("circuitOrderLocation2")) {
            newCircuitLocation = Array.isArray(inventoryAllLocations2)
                ? inventoryAllLocations2.find(r => parseInt(r.LocationId) === parseInt(locationID))
                : null;
        }
        dispatch(actions.change(model, locationID));

        var modelName = model.includes("circuitOrderLocation1") ? "circuitOrderLocation1" : (model.includes("circuitOrderLocation2") ? "circuitOrderLocation2" : "");

        if (modelName != "" && newCircuitLocation) {
            dispatch(actions.change(`circuitOrderForm.${modelName}.locationID`, newCircuitLocation.LocationId));
            dispatch(actions.change(`circuitOrderForm.${modelName}.locationSite`, newCircuitLocation.LocationSite));
            dispatch(actions.change(`circuitOrderForm.${modelName}.address1`, newCircuitLocation.LocationAddress1));
            dispatch(actions.change(`circuitOrderForm.${modelName}.address2`, newCircuitLocation.LocationAddress2));
            dispatch(actions.change(`circuitOrderForm.${modelName}.locationType`, newCircuitLocation.LocationType));
            dispatch(actions.change(`circuitOrderForm.${modelName}.locationCity`, newCircuitLocation.LocationCity));
            dispatch(actions.change(`circuitOrderForm.${modelName}.locationState`, newCircuitLocation.LocationState));
            dispatch(actions.change(`circuitOrderForm.${modelName}.locationCountry`, newCircuitLocation.CountryName));
            dispatch(actions.change(`circuitOrderForm.${modelName}.locationZip`, newCircuitLocation.LocationZip));
        }
        else {
            dispatch(actions.reset(`circuitOrderForm.${modelName}.locationSite`));
            dispatch(actions.reset(`circuitOrderForm.${modelName}.address1`));
            dispatch(actions.reset(`circuitOrderForm.${modelName}.address2`));
            dispatch(actions.reset(`circuitOrderForm.${modelName}.locationType`));
            dispatch(actions.reset(`circuitOrderForm.${modelName}.locationCity`));
            dispatch(actions.reset(`circuitOrderForm.${modelName}.locationState`));
            dispatch(actions.reset(`circuitOrderForm.${modelName}.locationCountry`));
            dispatch(actions.reset(`circuitOrderForm.${modelName}.locationZip`));
        }

    },
    selectBillingAccountID: (value, requestTypeID) => async (dispatch, state) => {
        const dealName = sessionStorage.getItem('DealName');
        var accountDetail = await httpGet('external/inventoryManager/getAccountDetailsModal/' + dealName + "/" + value);

        dispatch(actions.change('circuitOrderForm.circuitOrderDetails.billingAccountID', value));
        dispatch(actions.change('circuitOrderForm.circuitOrderDetails.financeAccountTypeName', accountDetail.AccountType));
        dispatch(actions.change('circuitOrderForm.circuitOrderDetails.clientName', accountDetail.Client));


        if (parseInt(requestTypeID) !== REQUEST_TYPES_ID.changeVendor &&
            parseInt(requestTypeID) !== REQUEST_TYPES_ID.newMobile &&
            parseInt(requestTypeID) !== REQUEST_TYPES_ID.simAndDevice &&
            parseInt(requestTypeID) !== REQUEST_TYPES_ID.newMobileDevice &&
            parseInt(requestTypeID) !== REQUEST_TYPES_ID.wifiDongleAndDataCard &&
            parseInt(requestTypeID) !== REQUEST_TYPES_ID.simAndDeviceBSA &&
            parseInt(requestTypeID) !== REQUEST_TYPES_ID.simOnlyBSA &&
            parseInt(requestTypeID) !== REQUEST_TYPES_ID.multiSIMBSA &&
            parseInt(requestTypeID) !== REQUEST_TYPES_ID.wifiDongleAndDataCardBIN &&
            parseInt(requestTypeID) !== REQUEST_TYPES_ID.voiceSIMBIN &&
            parseInt(requestTypeID) !== REQUEST_TYPES_ID.wifiDongleDataCardAndVoiceSIMBIN &&
            parseInt(requestTypeID) !== REQUEST_TYPES_ID.portIn) {
            dispatch(actions.change('circuitOrderForm.circuitOrderDetails.vendor', accountDetail.Vendor));
            dispatch(actions.change('circuitOrderForm.circuitOrderDetails.vendorID', accountDetail.VendorID));
            dispatch(actions.change('circuitOrderForm.circuitOrderDetails.currency', accountDetail.Currency));
            dispatch(actions.reset('circuitOrderForm.circuitOrderDetails.linkedCircuitID'));
        }    
    },

    selectCircuitTypeID: () => async (dispatch) => {
        dispatch(actions.reset('circuitOrderForm.circuitOrderDetails.linkedCircuitID'));
    },

    resetBillingDetails: (requestTypeID) => async (dispatch) => {
        dispatch(actions.reset('circuitOrderForm.circuitOrderDetails.billingAccountID'));
        dispatch(actions.reset('circuitOrderForm.circuitOrderDetails.financeAccountTypeName'));
        dispatch(actions.reset('circuitOrderForm.circuitOrderDetails.clientName'));

        if (parseInt(requestTypeID) !== REQUEST_TYPES_ID.changeVendor &&
            parseInt(requestTypeID) !== REQUEST_TYPES_ID.newMobile &&
            parseInt(requestTypeID) !== REQUEST_TYPES_ID.simAndDevice &&
            parseInt(requestTypeID) !== REQUEST_TYPES_ID.newMobileDevice &&
            parseInt(requestTypeID) !== REQUEST_TYPES_ID.wifiDongleAndDataCard &&
            parseInt(requestTypeID) !== REQUEST_TYPES_ID.simAndDeviceBSA &&
            parseInt(requestTypeID) !== REQUEST_TYPES_ID.simOnlyBSA &&
            parseInt(requestTypeID) !== REQUEST_TYPES_ID.multiSIMBSA &&
            parseInt(requestTypeID) !== REQUEST_TYPES_ID.wifiDongleAndDataCardBIN &&
            parseInt(requestTypeID) !== REQUEST_TYPES_ID.voiceSIMBIN &&
            parseInt(requestTypeID) !== REQUEST_TYPES_ID.wifiDongleDataCardAndVoiceSIMBIN &&
            parseInt(requestTypeID) !== REQUEST_TYPES_ID.portIn)
        {
            dispatch(actions.reset('circuitOrderForm.circuitOrderDetails.vendor'));
            dispatch(actions.reset('circuitOrderForm.circuitOrderDetails.vendorID'));
            dispatch(actions.reset('circuitOrderForm.circuitOrderDetails.currency'));
            dispatch(actions.reset('circuitOrderForm.circuitOrderDetails.linkedCircuitID'));
        }      
    },

    resetCircuitOrderForm: () => (dispatch) => {
        batch(() => {
            dispatch(actions.load("circuitOrderForm.circuitOrderDetails", circuitOrderInitialFormState));
            dispatch(actions.load("circuitOrderForm.circuitOrderLocation1", location1FormInitialState));
            dispatch(actions.load("circuitOrderForm.circuitOrderLocation2", location1FormInitialState));
            dispatch(actions.reset('circuitOrderForm'));
            dispatch(actions.reset("circuitOrderAccessForm"));
            dispatch(actions.reset("circuitOrderPipForm"));
            dispatch({ type: setCircuitOrderFormSubmitted, data: false });
        });
    },

    selectDate: (model, date) => (dispatch) => {
        dispatch(actions.change(model, date));
    },

    selectCircuitRank: (model, value) => async (dispatch) => {
        dispatch(actions.change(model, value));
        dispatch(actions.reset('circuitOrderForm.circuitOrderDetails.linkedCircuitID'));
    },
    getCircuitOrderAllEmployees: (page = 1, searchString = '') => async (dispatch, state) => {
        const pageSize = 15;

        dispatch({
            type: setEmployeeLoading,
            payload: true
        });

        let url = `external/inventory/getInventoryAllEmployees/${page}/${pageSize}`;
        if (searchString) {
            url += `?searchString=${encodeURIComponent(searchString)}`;
        }
        var res = await httpGet(url);
        if (res != null) {
            dispatch({
                type: getCircuitOrderAllEmployeesDropdown,
                payload: {
                    employees: res,
                    employeePage: page
                }
            });
            dispatch({
                type: setEmployeeLoading,
                payload: false
            });
        } else {
            dispatch({
                type: setEmployeeLoading,
                payload: false
            });
        }

    },
    getCircuitOrderAllLocations1: (page = 1, searchString = '') => async (dispatch, state) => {
        const pageSize = 15;
        dispatch({
            type: setLocation1Loading,
            payload: true
        });

        let url = `external/inventory/getAllLocationsWithDropdownList/${page}/${pageSize}`;
        if (searchString) {
            url += `?searchString=${encodeURIComponent(searchString)}`;
        }
        var res = await httpGet(url);
        if (res != null) {
            dispatch({
                type: getCircuitOrderAllLocations1,
                payload: {
                    locations1: res,
                    location1Page: page
                }
            });
            dispatch({
                type: setLocation1Loading,
                payload: false
            });
        } else {
            dispatch({
                type: setLocation1Loading,
                payload: false
            });
        }

    },
    getCircuitOrderAllLocations2: (page = 1, searchString = '') => async (dispatch, state) => {
        const pageSize = 15;
        dispatch({
            type: setLocation2Loading,
            payload: true
        });

        let url = `external/inventory/getAllLocationsWithDropdownList/${page}/${pageSize}`;
        if (searchString) {
            url += `?searchString=${encodeURIComponent(searchString)}`;
        }
        var res = await httpGet(url);
        if (res != null) {
            dispatch({
                type: getCircuitOrderAllLocations2,
                payload: {
                    locations2: res,
                    location2Page: page
                }
            });
            dispatch({
                type: setLocation2Loading,
                payload: false
            });
        } else {
            dispatch({
                type: setLocation2Loading,
                payload: false
            });
        }

    },
    getCircuitOrderSubCircuitTypes: (circuitTypeId, page = 1, searchString = '') => async (dispatch, state) => {
        const pageSize = 15;

        dispatch({
            type: setSubCircuitTypeLoading,
            payload: true
        });

        let url = `external/inventory/getInventorySubCircuitTypesByCircuitType/${circuitTypeId}/${page}/${pageSize}`;
        if (searchString) {
            url += `?searchString=${encodeURIComponent(searchString)}`;
        }
        else {
            dispatch(actions.reset('inventoryCircuitForm.circuitDetails.subCircuitTypeID'));
        }

        try {
            const res = await httpGet(url);

            if (res != null) {
                dispatch({
                    type: getCircuitOrderSubCircuitTypesDropdown,
                    payload: {
                        subCircuitTypes: res,
                        subCircuitTypePage: page
                    }
                });
                dispatch({
                    type: setSubCircuitTypeLoading,
                    payload: false
                });
            } else {
                dispatch(actions.reset('inventoryCircuitForm.circuitDetails.subCircuitTypeID'));
                dispatch({
                    type: setSubCircuitTypeLoading,
                    payload: false
                });
            }
        } catch (err) {
            dispatch({
                type: setSubCircuitTypeLoading,
                payload: false
            });
        }
    },
    GetlinkCircuitsByVendorIdAndCircuitTypeId: (circuitId, circuitTypeId, newVendorID, page = 1, searchString = '') => async (dispatch, state) => {
        const pageSize = 15;
        dispatch({ type: setLinkedCircuitsLoading, payload: true });

        const dealName = sessionStorage.getItem('DealName');
        let url = `external/inventoryManager/GetlinkCircuitsByVendorIdAndCircuitTypeId/${dealName}/${circuitId}/${circuitTypeId}/${newVendorID}/${page}/${pageSize}`;

        if (searchString) {
            url += `?searchString=${encodeURIComponent(searchString)}`;
        }
        else {
            dispatch(actions.reset('inventoryCircuitForm.circuitDetails.linkedCircuitID'));
        }

        try {
            const res = await httpGet(url);

            if (res !== null) {
                dispatch({
                    type: getlinkCircuitsByVendorIdAndCircuitTypeId,
                    payload: {
                        linkCirccuits: res,
                        linkedCircuitsPage: page
                    }
                });
                dispatch({
                    type: setLinkedCircuitsLoading,
                    payload: false
                });
            } else {
                dispatch(actions.reset('inventoryCircuitForm.circuitDetails.linkedCircuitID'));
                dispatch({
                    type: setLinkedCircuitsLoading,
                    payload: false
                });
            }
        } catch (err) {
            dispatch({
                type: setLinkedCircuitsLoading,
                payload: false
            });
        }
    },
    getCircuitOrderAllAccountDetails: (vendorId, page = 1, searchString = '') => async (dispatch, state) => {
        const pageSize = 15;

        dispatch({
            type: setBillingAccountLoading,
            payload: true
        });

        let url = `external/order/getOrderBillingAccounts/${vendorId}/${page}/${pageSize}`;
        if (searchString) {
            url += `?searchString=${encodeURIComponent(searchString)}`;
        }

        try {
            const res = await httpGet(url);

            if (res != null) {
                dispatch({
                    type: getCircuitOrderAllAccountDetailsDropdown,
                    payload: {
                        billingAccounts: res,
                        billingAccountPage: page,
                        isLoading: false
                    }
                });                
            } else {
                dispatch({
                    type: setBillingAccountLoading,
                    payload: false
                });
            }
        } catch (err) {
            dispatch({
                type: setBillingAccountLoading,
                payload: false
            });
        }
    },
    getOrderCircuitCostCenterListDropdown: (pageIndex = 1, searchString = '') => async (dispatch, state) => {
        const pageSize = 15;

        dispatch({
            type: setCostCodeLoading,
            payload: true
        });
        let url = `external/autosuggest/getCostCodesList/${pageIndex}/${pageSize}`;

        if (searchString) {
            url += `?searchString=${encodeURIComponent(searchString)}`;
        }
        try {
            var res = await httpGet(url);

            if (res != null) {
                dispatch({
                    type: getOrderCircuitCostCenterList,
                    payload: {
                        costCode: res,
                        costCodePage: pageIndex
                    }
                });
                dispatch({
                    type: setCostCodeLoading,
                    payload: false
                });
            } else {
                dispatch({
                    type: setCostCodeLoading,
                    payload: false
                });
            }
        }
        catch (e) {
            dispatch({
                type: setCostCodeLoading,
                payload: false
            });
        } finally {
            dispatch({
                type: setCostCodeLoading,
                payload: false
            });
        }
    },
    getOrderCircuitGlCodeListDropdown: (pageIndex = 1, searchString = '') => async (dispatch, state) => {
        const pageSize = 15;

        dispatch({
            type: setGlCodeLoading,
            payload: true
        });

        try {
            var url = `external/autosuggest/GetGLCodesList/${pageIndex}/${pageSize}`;

            if (searchString) {
                url += `?searchString=${encodeURIComponent(searchString)}`;
            }

            var res = await httpGet(url);

            if (res != null) {
                dispatch({
                    type: getOrderCircuitGlCodeList,
                    payload: {
                        glCode: res
                        , glCodePage: pageIndex
                    }
                });
            } else {
                dispatch({
                    type: setGlCodeLoading,
                    payload: false
                });
            }
        } catch (e) {
            dispatch({
                type: setGlCodeLoading,
                payload: false
            });
        }
        finally {
            dispatch({
                type: setGlCodeLoading,
                payload: false
            });
        }
    },
}

async function getCircuitOrderAllCircuitStatuses() {
    try {
        var result = await httpGet('internal/circuit/getCircuitStatuses');
        return result;
    }
    catch (e) {
        return [];
    }
}

async function getCircuitOrderCircuitTypesByCategory(categoryid) {
    try {
        var result = await httpGet('external/inventory/getInventoryCircuitTypesByCategory/' + categoryid);
        return result;
    }
    catch (e) {
        return [];
    }
}

async function getCircuitOrderAllCircuitRankings() {
    try {
        var result = await httpGet('internal/circuit/GetCircuitRankings');
        return result;
    }
    catch (e) {
        return [];
    }
}

async function getCircuitOrderAllLocationsDropdown(page, searchString, dispatch) {
     const pageSize=15;  
    
    dispatch({ 
        type: setLocationLoading, 
        payload: true 
    });
    try {
        let url = `external/inventory/getAllLocationsWithDropdownList/${page}/${pageSize}`;
        if(searchString) {
            url += `/${encodeURIComponent(searchString)}`;
        }
        var result = await httpGet(url);
        return result;
    }
    catch (e) {
        return [];
    } finally {
        dispatch({ 
            type: setLocationLoading, 
            payload: false 
        });
    }
}

async function getCircuitOrderlinkCircuitsByBillingAccountIdAndCircuitTypeId(circuitId, circuitTypeId, billingAccountId){
    try {

        const dealName = sessionStorage.getItem('DealName'); 
        var linkCirccuits = await httpGet('external/inventoryManager/GetlinkCircuitsByBillingAccountIdAndCircuitTypeId/' + dealName + "/" + circuitId + '/' + circuitTypeId + '/' + billingAccountId);
        if (linkCirccuits.length > 0) {
            return linkCirccuits;
        }    

    }
    catch (e) {
        return [];
    }
}

export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case getCircuitOrder:
            return {
                ...state,
                fetchingCircuitOrder: action.data.fetching,
                CircuitOrderId: action.data.CircuitOrderId,
                CircuitId: action.data.CircuitId,
                OrderId: action.data.OrderId,
                OrderCircuitDetailId: action.data.OrderCircuitDetailId

            }
        case getCircuitOrderAllCircuitStatusesDropdown:
            return {
                ...state,
                circuitOrderStatusDropdown: action.data
            };
        case getCircuitOrderCircuitTypesByCategoryDropdown:
            return {
                ...state,
                CircuitOrderCircuitTypesByCategoryDropdown: action.data
            };
        case getCircuitOrderSubCircuitTypesDropdown:
            const { subCircuitTypes, subCircuitTypePage } = action.payload;
            return {
                ...state,
                CircuitOrderSubCircuitTypesDropdown:
                    subCircuitTypePage === 1
                        ? subCircuitTypes
                        : [...state.CircuitOrderSubCircuitTypesDropdown, ...subCircuitTypes],
                hasMoreSubCircuitType: subCircuitTypes.length > 0,
                subCircuitTypePage: subCircuitTypePage
            };
        case getCircuitOrderAllCircuitRankingsDropdown:
            return {
                ...state,
                CircuitOrderAllCircuitRankingsDropdown: action.data
            };
        case getCircuitOrderAllAccountDetailsDropdown:
            const { billingAccounts, billingAccountPage, isLoading } = action.payload;
            return {
                ...state,
                CircuitOrderAllAccountDetailsDropdown: billingAccountPage === 1 ? billingAccounts : [...state.CircuitOrderAllAccountDetailsDropdown, ...billingAccounts],
                hasMoreBillingAccount: billingAccounts.length > 0,
                billingAccountPage: billingAccountPage,
                isBillingAccountLoading: isLoading
            }
        case getlinkCircuitsByVendorIdAndCircuitTypeId: {
            const { linkCirccuits, linkedCircuitsPage } = action?.payload;
            const safeCircuits = Array.isArray(linkCirccuits) ? linkCirccuits : [];

            let newOptions = state.CircuitOrderLinkedCircuitsOptions;

            if (linkedCircuitsPage === 1) {
                newOptions = safeCircuits;
            } else if (safeCircuits.length > 0) {
                newOptions = [...state.CircuitOrderLinkedCircuitsOptions, ...safeCircuits];
            }

            return {
                ...state,
                CircuitOrderLinkedCircuitsOptions: newOptions,
                hasMoreLinkedCircuits: safeCircuits.length > 0,
                linkedCircuitsPage
            };
        }
        case getCircuitOrderAllEmployeesDropdown:
            const { employees, employeePage } = action.payload;
            return {
                ...state,
                CircuitOrderAllEmployeesDropdown: employeePage === 1 ? employees : [...state.CircuitOrderAllEmployeesDropdown, ...employees],
                hasMoreLocation: employees.length > 0,
                employeePage: employeePage
            }
        case getCircuitOrderAllLocations: {
            const { data, locationPage } = action.payload;
            const safeData = Array.isArray(data) ? data : [];

            return {
                ...state,
                inventoryAllLocations: locationPage === 1
                    ? safeData
                    : [...(state.inventoryAllLocations || []), ...safeData],
                hasMoreLocation: safeData.length > 0,
                locationPage
            };
        }
        case getCircuitOrderAllLocations1:
            const { locations1, location1Page } = action.payload;
            const newLocations1 = Array.isArray(locations1) ? locations1 : [];
            return {
                ...state,
                inventoryAllLocations1: location1Page === 1
                    ? [...newLocations1]
                    : [...state.inventoryAllLocations1, ...newLocations1],
                hasMoreLocation1: newLocations1.length > 0,
                location1Page: location1Page
            }
        case getCircuitOrderAllLocations2:
            const { locations2, location2Page } = action.payload;
            const newLocations2 = Array.isArray(locations2) ? locations2 : [];
            return {
                ...state,
                inventoryAllLocations2: location2Page === 1
                    ? [...newLocations2]
                    : [...state.inventoryAllLocations2, ...newLocations2],
                hasMoreLocation2: newLocations2.length > 0,
                location2Page: location2Page
            }
        case setLocation1Loading:
            return {
                ...state,
                isLocation1Loading: action.payload
            }
        case setLocation2Loading:
            return {
                ...state,
                isLocation2Loading: action.payload
            }
        case setCircuitOrderFormSubmitted:
            return {
                ...state,
                formSubmitted: action.data
            };
        case getOrderCircuitCostCenterList:
            const { costCode, costCodePage } = action.payload;
            return {
                ...state,
                circuitCostCenterList: costCodePage === 1
                    ? costCode
                    : [...state.circuitCostCenterList, ...costCode],
                costCodePage,
                hasMoreCostCode: costCode.length > 0
            };
        case getOrderCircuitGlCodeList:
            const { glCode, glCodePage } = action.payload;

            return {
                ...state,
                circuitGlCodeList: glCodePage === 1
                    ? glCode
                    : [...state.circuitGlCodeList, ...glCode],
                glCodePage,
                hasMoreGLCode: glCode.length > 0
            };
        case setEmployeeLoading:
            return {
                ...state,
                isEmployeeLoading: action.payload
            };
        case setLocationLoading:
            return {
                ...state,
                isLocationLoading: action.payload
            }
        case setSubCircuitTypeLoading:
            return {
                ...state,
                isSubCircuitTypeLoading: action.payload
            }
        case setLinkedCircuitsLoading:
            return {
                ...state,
                isLinkedCircuitsLoading: action.payload
            }
        case setBillingAccountLoading:
            return {
                ...state,
                isBillingAccountLoading: action.payload
            }
        case setCostCodeLoading:
            return {
                ...state,
                isCostCodeLoading: action.payload
            }
        case setGlCodeLoading:
            return {
                ...state,
                isGLCodeLoading: action.payload
            }
        default:
            return state;
    }
}